<template>
  <b-container fluid class="mt--10">
    <b-row>
      <b-col cols="12" md="5" xl="4">  
        <div class="bg-white rounded p-3" style="height: 340px">
          <div class="dashboard-info bg-danger mb-5">
            <span>{{ formatPremium(totalPremiumAllProducts) }}</span>
            <div>POLICIES TOTAL PREMIUM</div>
          </div>
          <div v-for="product in totalPremiumDatas" :key="product.productCode" class="mb-3">
            <h3 class="mb-3">{{ product.productName }}</h3>
            <b-progress :max="totalPremiumAllProducts || 1" height="1.5rem">
              <b-progress-bar :value="product.totalPremium" :style="{backgroundColor: product.color}">
                <span><strong>{{ formatPremium(product.totalPremium) }}</strong></span>
              </b-progress-bar>
            </b-progress>
          </div>
        </div>
      </b-col>
      <b-col cols="12" md="7" xl="8">
        <card type="secondary" header-classes="bg-transparent">
          <b-row align-v="center" slot="header">
            <b-col>
              <h5 class="h3 mb-0">Total Bound Policies Number 
                <b-badge variant="danger" class="text-lg">{{ totalBoundPolicies }}</b-badge>
              </h5>
            </b-col>
          </b-row>
          <line-chart
            :height="100"
            ref="bigChart"
            :chart-data="bigLineChart.chartData"
            :extra-options="bigLineChart.extraOptions"
          >
          </line-chart>
          <hr/>
          <div class="float-right float-xl-left">
            <div v-for="(label, index) in labelsChart" :key="index">
              <p class="mt--3">
                <i class="fa fa-square" aria-hidden="true" v-bind:style="{ color: label.color }"></i>
                {{ label.title }}
              </p>
            </div>
          </div>
        </card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import * as chartConfigs from "../../components/Charts/config.js";
import LineChart from "../../components/Charts/LineChart.js";
import BarChart from "../../components/Charts/BarChart.js";
import Spinner from "./Spinner.vue";
import moment from "moment";
import { Button, Dropdown, DropdownItem, DropdownMenu } from "element-ui";
import { formattingMethods } from "../../helpers/formatting";
import { getReportingProducts } from "../../helpers/reportingProducts";
import { isBoundStatus } from "../../helpers/reportingStatuses";

export default {
  name: "charts",
  props: {
    activeIndex: {
      type: Number,
      required: true
    },
    dataChart: {
      type: Array,
      required: true
    },
    reportingProducts: {
      type: Array,
      default: () => []
    },
    submitDate: {
      type: Date,
      required: true
    }
  },
  data() {
    return {
      totalPremiumAllProducts: 0,
      totalPremiumDatas: [],
      totalBoundPolicies: 0,
      bigLineChart: {
        activeIndex: 0,
        chartData: {},
        extraOptions: chartConfigs.lineChartOptionsBlue,
      },
      labels: [],
      isLoading: true,
      labelsChart: [],
    };
  },
  computed: {
    products() {
      return this.reportingProducts.length
        ? this.reportingProducts
        : getReportingProducts();
    }
  },
  methods: {
    calculateTotalPremium(rowsByProduct) {
      this.totalPremiumDatas = this.products.map((product) => {
        const rows = rowsByProduct[product.Product_code] || [];
        const totalPremium = _.sumBy(
          rows.filter((policy) => policy.total_policy_premium),
          (policy) => parseFloat(policy.total_policy_premium)
        );
        return {
          productCode: product.Product_code,
          productName: product.Product_name,
          totalPremium: totalPremium || 0,
          color: product.color,
        };
      });
      this.totalPremiumAllProducts = _.sumBy(this.totalPremiumDatas, "totalPremium");
      this.labelsChart = this.products.map((p) => ({
        title: p.Product_name,
        color: p.color,
      }));
    },

    formatPremium(value) {
      return formattingMethods.formatCurrencyString(value);
    },

    async initBigChart(index) {
      let data = await this.dataChart
      data = _.filter(data, (item) => isBoundStatus(item.status));
      this.totalBoundPolicies = data.length

      const rowsByProduct = {};
      this.products.forEach((product) => {
        rowsByProduct[product.Product_code] = _.filter(
          data,
          (item) => item.product === product.Product_code
        );
      });

      this.calculateTotalPremium(rowsByProduct)

      let monthName = null
      if(this.activeIndex === 0) {
        monthName = item => moment(item.date_created, 'YYYY-MM-DD').format('MMM');
      } else {
        monthName = item => moment(item.date_created, 'YYYY-MM-DD').format('D');
      }

      const datasets = this.products.map((product) => ({
        label: product.Product_name,
        borderColor: product.color,
        data: this.filterData(
          index,
          _.groupBy(rowsByProduct[product.Product_code] || [], monthName)
        ),
      }));

      this.bigLineChart.chartData = {
        datasets,
        labels: this.labels[index],
      };
      this.bigLineChart.activeIndex = index;
    },
    setLabels() {
      this.labels = []
      let labelsYear = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]
      let labelsMonth = []
      for (let index = 1; index <= new Date(this.submitDate.getFullYear(), this.submitDate.getMonth() + 1, 0).getDate(); index++) {
        labelsMonth.push(index)
      }
      this.labels.push(labelsYear, labelsMonth)
    },
    filterData(index, groupByMonth) {
      const data = []
      this.labels[index].forEach(element => {
        if (groupByMonth[element]) {
          data.push(groupByMonth[element].length)
        } else {
          data.push(0)
        }
      });
      return data
    },
  },
  watch: {
    activeIndex() {
      this.initBigChart(this.activeIndex)
      this.setLabels()
    },
    dataChart() {
      this.initBigChart(this.activeIndex)
      this.setLabels()
    },
    reportingProducts: {
      deep: true,
      handler() {
        this.initBigChart(this.activeIndex)
      }
    }
  },
  async mounted() {
    this.setLabels()
  },
  components: {
    LineChart,
    BarChart,
    Spinner,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button
},
};
</script>

<style scoped>
.dashboard-info {
  color: white;
  font-size: 16px;
  font-weight: 600;
  padding: 10px;
}
.dashboard-info span {
  font-size: 25px;
}
</style>
